module.exports = __webpack_public_path__ + "img/logo-aportes-en-linea-retina.0767e87f.png";